import { i18n } from "@lingui/core";

export const locales = {
  en: "English",
  es: "Español",
};
export const defaultLocale = "en";

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
export async function dynamicActivate(locale) {
  try {
    const { messages } = await import(`../locales/${locale}.po`);
    i18n.load(locale, messages);
    i18n.activate(locale);
  } catch (e) {
    console.error(`Failed to load locale: ${locale}`);
  }
}
